import { Gauge, Info } from 'lucide-react';
import Screen from '../../demo/Screen';
import { ProductChip } from './ProductDetail';
import { ReportCard } from './HealthScoreParts';
import ScoreSimulator from './ScoreSimulator';
import { ADJUSTMENTS, DOMAINS, TIERS } from './scoreModel';
import './HealthScores.css';

/* The framework at a glance, counted from the model. */
const FACTS = [
  { n: DOMAINS.reduce((sum, d) => sum + d.params.length, 0), label: 'results scored' },
  { n: DOMAINS.length, label: 'body systems, weighted' },
  { n: ADJUSTMENTS.length, label: 'lifestyle factors' },
  { n: TIERS.length, label: 'categories' },
];

export default function HealthScores() {
  return (
    <Screen id="product.health-scores" title="Health scores" className="hs">
      <div className="pd-hero hs-hero">
        <div className="pd-intro">
          <ProductChip icon={Gauge} name="Health scores" stage="Counsel" tone="counsel" />
          <h1 className="headline pd-headline hs-headline">
            Wellness Score <br />
            and <em>Risk Score.</em>
          </h1>
          <ul className="hs-facts">
            {FACTS.map((f) => (
              <li key={f.label}>
                <strong>{f.n}</strong>
                <span>{f.label}</span>
              </li>
            ))}
          </ul>
        </div>
        <ReportCard />
      </div>

      <ScoreSimulator />

      <p className="hs-note">
        <Info size={14} aria-hidden="true" />
        <span>
          Illustrative, de-identified example. Point tables, weights and categories follow the Comprehensive Wellness
          Score framework (ADA, KDIGO, WHO, ACC/AHA guidance); final thresholds are being confirmed with our clinical
          team.
        </span>
      </p>
    </Screen>
  );
}
